/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Ronnel Bedana - ronnel@internalvaluation.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


import { Component, OnInit, OnDestroy } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { FileSystemFileEntry, NgxFileDropEntry } from 'ngx-file-drop';
import { Subject } from 'rxjs';
import { Report, ReportFile } from 'src/app/model';
import { ReportProvider } from 'src/app/providers';
import { LogService } from 'src/app/services';
@Component({
  selector: 'upload-file-modal',
  templateUrl: './upload-file.modal.html',
  styleUrls: ['./upload-file.modal.scss']
})
export class UploadFileModal implements OnInit, OnDestroy {
  subject: Subject<ReportFile[]>;
  subscription: any;
  folderName = '';
  path: string;
  report: Report;
  selected: ReportFile;
  uploadedFiles: File[] = [];

  constructor(
    public bsModalRef: BsModalRef,
    private modalService: BsModalService,
    private reportProvider: ReportProvider,
    private logService : LogService
  ) { }

  ngOnInit(): void {
    // Fix for when user clicks `ESC` instead of clicking, no Event was firing
    this.subscription = this.modalService.onHide.subscribe((reason: string) => {
      if (reason === 'esc')
        this.onCancel();
    });
  }

  ngOnDestroy(): void {
    if (this.subscription)
      this.subscription.unsubscribe();
  }

  onCancel(): void {
    this.bsModalRef.hide();
    this.subject.next(null);
    this.subject.complete();
  }

  fileDropped(files: NgxFileDropEntry[]): void {
    const formData = new FormData();
    formData.append("path", this.path);
    for (const droppedFile of files) {
      if (droppedFile.fileEntry.isFile) {
        const fileEntry = droppedFile.fileEntry as FileSystemFileEntry;
        fileEntry.file((file: File) => {
          formData.append('files', file, droppedFile.relativePath);
        });
      }
    }

    this.reportProvider.addReportFiles(this.report.ID, formData, this.selected.ID)
      .subscribe(data => {
        if (data.success) {
          this.bsModalRef.hide();
          this.subject.next(ReportFile.parseArray(data.result));
          this.subject.complete();
        }
      }, err => {
        this.logService.error(err);
      });
  }

}
